export default __webpack_public_path__ + "static/media/delete-icon.c8ab3321.svg";